import { formatDate } from "../utils/format-utils";

export default class InPersonLog {
  inPersonLogId?: number | null;
  clientId?: number | null;
  clientName?: string | null;
  providerId?: number | null;
  providerName?: string | null;
  serviceId?: number | null;
  serviceType?: string | null;
  payPeriodStart?: Date | null;
  payPeriodEnd?: Date | null;
  processedAt?: Date | null;
  fileId?: number | null;

  public constructor(params: InPersonLog = {} as InPersonLog) {
    let {
      inPersonLogId = 0,
      clientId = null,
      clientName = null,
      providerId = null,
      providerName = null,
      serviceId = null,
      serviceType = null,
      payPeriodStart = null,
      payPeriodEnd = null,
      processedAt = null,
      fileId = null,
    } = params;
    this.inPersonLogId = inPersonLogId;
    this.clientId = clientId;
    this.clientName = clientName;
    this.providerId = providerId;
    this.providerName = providerName;
    this.serviceId = serviceId;
    this.serviceType = serviceType;
    this.payPeriodStart = payPeriodStart;
    this.payPeriodEnd = payPeriodEnd;
    this.processedAt = processedAt;
    this.fileId = fileId;
  }
  get formattedPayPeriodStart() {
    return formatDate(this.payPeriodStart);
  }
  get formattedPayPeriodEnd() {
    return formatDate(this.payPeriodEnd);
  }
}
